import { BoxShadow, IH2OTheme, Sizes } from '@h2oai/ui-kit';

export const loginTopStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  marginBottom: '1rem',
};

export const startDatePickerStyle = {
  marginRight: '1rem',
  width: '170px',
};

export const endDatePickerStyle = {
  width: '170px',
};

export const searchAreaStyle = {
  display: 'flex',
  alignItems: 'center',
};

export const searchStyle = {
  width: '250px',
  marginRight: '20px',
};

export const tableAreaStyle = {
  marginTop: '1rem',
  flexGrow: 1,
};

export const TableStyle = (theme: IH2OTheme): React.CSSProperties => ({
  backgroundColor: theme.palette?.gray200,
  height: '100%',
  overflowX: 'auto' as 'auto' | 'hidden' | 'scroll' | 'visible',
});

export const UserLoginPageStatStyles = (theme: IH2OTheme) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr',
  gap: '20px',
  padding: Sizes.padding,
  marginBottom: '2rem',
  backgroundColor: theme.palette?.white,
  borderRadius: Sizes.borderRadius,
  boxShadow: BoxShadow,
  color: theme.palette?.gray300,
});

export const InfoLabel = {
  fontWeight: 'bold',
  color: '#555',
};

export const InfoValue = {
  fontWeight: 'normal',
  color: '#000',
  fontSize: '16px',
};
